// extracted by mini-css-extract-plugin
export default {"container":"LockBadge_container__LWPeI"};